import { apiSlice } from '../apiSlice';

interface paymentSemesters {
  campusCode: string;
  semesterCode: number;
}

export const semestersAPI = apiSlice
  .enhanceEndpoints({ addTagTypes: ['Payment'] })
  .injectEndpoints({
    endpoints: (build) => ({
      paymentSemesters: build.mutation({
        query: ({ campusCode, semesterCode }: paymentSemesters) => ({
          url: `/mgmt/semesters/${campusCode}/${semesterCode}`,
          method: 'PATCH',
        }),
        invalidatesTags: ['Payment'],
      }),
    }),
  });

export const {
  usePaymentSemestersMutation,
}: any = semestersAPI;
